module.exports = __webpack_public_path__ + "static/Tomilola__Ogedengbe-c793c506fa50f1cc22e8424c207336aa.png";